<template>
  <SwapMenu2 :swapid="swapid" :period="period" title="SPEEDO METER" margin="1"> 
    <template v-slot:menu>
        <li><a v-if="interval == 0" 
            class="dropdown-item" @click=start_interval()>Start Interval</a></li>
        <li><a v-if="interval > 0" 
            class="dropdown-item" @click=stop_interval()>Stop Interval</a></li>
    </template>
  </SwapMenu2>
  <p class="topleft">{{symbolmeaning}}</p>
  <div>
    <canvas :id="canvasid" style='margin-top:0px;width:100%;height:210px'></canvas>
  </div>
  <canvas @mousemove="showsymbol($event)" style='width:80%;height:20' :id="canvasid + 'lab'"></canvas> 
</template>

<script>
import { showspeedo, iconsStates, speedoParm }  from '../js/speedometer.js'
import SwapMenu2 from './SwapMenu2.vue' 

const iconhover = [
    [ 'battery', "Mandatory Connection Off", 70 ],
    [ 'engineFail', "NO LOGON", 110],
    [ 'drift', "Timeout SendS", 150],
    [ 'highBeam', "Timeout ReplyP", 180],
    [ 'lock', "Timeout SendTab", 210],
    [ 'seatBelt', "Timeout Rcv Tab", 250],
    [ 'engineTemp', "Q FULL Rcv Tab", 290],
    [ 'stab', "Q Full Send Tab", 315],
] ;


export default {
  name: 'SpeedoComp',
  components : {
      SwapMenu2
  },
  props: {
    period : Number,
    globid : String,
    swapid : String,
    screensize : String,
    title : String
  },
  mounted() {
    this.runspeedo();
    this.start_interval();
  },
  unmounted() {
    this.stop_interval();
  },
  data() {
    return { symbolmeaning: 
                'hover on the label to get the symbol meaning', 
            interval : 0
           } ;
  },
  watch : {
    swapseq : function () {
        this.runspeedo();
    }
  },
  computed: {
    canvasid() { return "speedo" + this.globid ; },
    swapseq() {
      let swap = this.$store.getters.getswap_byid(this.swapid) ;
      if (! swap) return 0 ;
      return swap.seq ;	
    }
  },
  methods : {
     stop_interval() {
         if (this.interval) {
            clearInterval(this.interval) ;
            this.interval = 0 ;
         }
     },
     start_interval() {
         if (this.interval == 0) {
            this.interval = setInterval( () => 
            { this.$store.commit("reqswapdata",this.swapid) }, this.period) ;
         }
     },
     showsymbol(event) {
        if (event.clientX) {
            let x = event.clientX ;
            if (x < 40 || x >= 300) 
                this.symbolmeaning = event.clientX  ;
            else {
              let i ;
              for (i = 0 ; i < iconhover.length ; i++) {
                if (x < iconhover[i][2])  {
                  this.symbolmeaning = event.clientX + ": " + iconhover[i][1] ;
                  break ;
                }
              }
              if (i >= iconhover.length)
                 this.symbolmeaning = "" ;
            }
        }
        else
            this.symbolmeaning = "event not defined" ;
     },
     showdown() {
        speedoParm.scalespeedo = 1 ;
        speedoParm.speedrecv =  0 ;
        speedoParm.speedsend = 0 ;
        speedoParm.gas = 0 ;
        speedoParm.tacho =  0 ;
        speedoParm.mileage = 0 ;
        speedoParm.speedPeriod = "OFF" 
        speedoParm.markFillColor = "#888888" ;
        iconsStates.drift = 0 ;     
        iconsStates.highBeam = 0 ;  
        iconsStates.lock =  0 ;
        iconsStates.seatBelt =  0 ;  
        iconsStates.engineTemp = 0 ;
        iconsStates.stab =  0 ;
        showspeedo(this.canvasid) ;
    },
    setup_left(swap) {
        let logaddr = swap.sdata.logaddr ;
        if (! logaddr) return ;
        let nologon = logaddr.find((obj) => obj.s == 0 ) 
        iconsStates.engineFail = (nologon) ? 2 : 0 ;

        iconsStates.battery = 0 ;
        if (swap.manconn ) {
           for (let i in swap.manconn) 
              if (! logaddr.find( (obj) => obj.a == swap.manconn[i] )) {
                iconsStates.battery = 2 ;
                break ;
              }
        }
        // iconsStates.oil = 2 ;
    },
    setup_main(speedo) {
        let x = Math.max(speedo.txdata.totinc, speedo.txdata.totout)
        let mul = 1 ;
        let interval = speedo.period ;
        if (interval < 1) interval = 1 ;

        speedoParm.scalespeedo = 1 ;

        if (x <= interval * 3 ) {
            speedoParm.speedPeriod = "Mn" 
            mul = 60 ;
        }
        if (x <= interval * 30 ) {
            speedoParm.scalespeedo = 10 ;
            speedoParm.speedPeriod = "s" 
            mul = 10 ;
        }
        else if ( (x / interval) < 200) {
            speedoParm.speedPeriod = "s" 
            mul = 1;
        }
        else {
            speedoParm.speedPeriod = "10x" 
            mul = 0.1 ;
        }

        speedoParm.speedrecv = speedo.txdata.totinc * mul / (200 * interval) ;
        speedoParm.speedsend = speedo.txdata.totout * mul / (200 * interval) ;

        speedoParm.scalegas = Math.trunc(speedo.totapr / 20) + 1 ;
        speedoParm.gas = speedo.totapr / (20 * speedoParm.scalegas) ;

        speedoParm.scaletacho = Math.trunc(speedo.totconn / 8) + 1 ;
        speedoParm.tacho = speedo.totconn / (8 * speedoParm.scaletacho) ;

        speedoParm.mileage = speedo.totmsg ;
        speedoParm.markFillColor = "#ffffff" ;

        iconsStates.drift =      speedo.txdata.c112 ; // ToutsendS 
        iconsStates.highBeam =   speedo.txdata.c113 ; // ToutreplyP ;
        iconsStates.lock =       speedo.txdata.c114 ; // Toutsndtab ;
        iconsStates.seatBelt =   speedo.txdata.c115 ; // Toutrcvtab ;
        iconsStates.engineTemp = speedo.txdata.c116 ; // Qfullrcvtab ;
        iconsStates.stab =       speedo.txdata.c117 ; // Qfullsndtab ;

        // iconsStates.dippedBeam iconsStates.brake iconsStates.abs 
    },
    
    runspeedo() {
        let swap = this.$store.getters.getswap_byid( parseInt(this.swapid )) ;
        if (! (swap && swap["speedo"])) {
           return this.showdown(this.canvasid) ;
        }
        this.setup_main(swap.speedo) ;
        this.setup_left(swap) ;
        // let filkeys = [ "drift", "highBeam", "lock",  "seatBelt", "engineTemp", "stab" ] ; 
        Object.keys(iconsStates).forEach( 
           (icon) => 
           { if (iconsStates[icon] > 2) iconsStates[icon] = 2 ; }
        ); 
        // console.log (speedoParm.scaletacho) ;
        showspeedo(this.canvasid) ;
    }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

<style scoped>
.scroll01 {
  margin: 4px, 4px;
  padding-left: 100px;
  background-color: white;
  width: 100%;
  height: 250px ;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.topleft {
  text-align:left ;
  font-size: 10pt;
  color : red ;
  width : auto ;
  height : 20px ;
  top : 0px ;
  left : 0px ;
  display: inline-block ;
  position : relative ;
}
</style>
